import React from "react";
import { Stack, Text, Columns, Column } from "@origin-digital/ods-core";
import { renderWithBold } from "./renderWithBold";
import { ConsentParagraph, ConsentScript } from "./concessionConsentScripts";

const decorate = (
  node: React.ReactNode,
  italic?: boolean,
  bold?: boolean
): React.ReactNode => {
  let result: React.ReactNode = node;
  if (bold) result = <strong>{result}</strong>;
  if (italic) result = <em>{result}</em>;
  return result;
};

const Bullet: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Columns space="xsmall" alignY="top">
    <Column width="content">
      <Text>{"•"}</Text>
    </Column>
    <Column>
      <Text>{children}</Text>
    </Column>
  </Columns>
);

const renderParagraph = (p: ConsentParagraph, key: number): React.ReactNode => {
  const content = decorate(
    renderWithBold(p.text, p.boldPhrases),
    p.italic,
    p.bold
  );
  if (p.variant === "list-item") {
    return <Bullet key={key}>{content}</Bullet>;
  }
  return <Text key={key}>{content}</Text>;
};

const ConsentScriptContent: React.FC<{ script: ConsentScript }> = ({
  script,
}) => (
  <Stack space="medium">
    {script.sections.map((section, sIdx) => (
      <Stack space="small" key={sIdx}>
        {section.subheading && (
          <Text weight="medium">{section.subheading}</Text>
        )}
        {section.paragraphs.map((p, pIdx) => renderParagraph(p, pIdx))}
      </Stack>
    ))}
  </Stack>
);

export default ConsentScriptContent;
